import { createFileRoute } from "@tanstack/react-router"
import { EvaluationsPage } from "@/assignment"

export const Route = createFileRoute("/(user)/t/$tenantSlug/evaluations")({
  validateSearch: (search): { page?: number } => ({
    page:
      typeof search.page === "number" && search.page > 1
        ? search.page
        : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return <EvaluationsPage />
}
